import React, { useCallback, useEffect, useState } from "react";
import { getMyInvitations, answerMyInvitation } from "../app/UrlCrud";

// The signed-in user's pending organisation invitations with Accept / Decline. Used on the
// "no active organisation" page and from the organisation switcher. Nothing is joined until Accept.
export default function MyInvitations({ onAccepted, onChanged }) {
    const [invites, setInvites] = useState(null);
    const [busyId, setBusyId] = useState(null);
    const [message, setMessage] = useState(null);

    const load = useCallback(() => {
        return getMyInvitations()
            .then(({ data }) => {
                setInvites(data || []);
                if (onChanged) onChanged(data || []);
            })
            .catch(() => setInvites([]));
    }, [onChanged]);

    useEffect(() => {
        load();
    }, [load]);

    const answer = (invite, accept) => {
        setBusyId(invite._id);
        setMessage(null);
        answerMyInvitation(invite._id, accept)
            .then(() => {
                setMessage({
                    type: "success",
                    text: accept ? `You joined ${invite.companyName}.` : `You declined the invitation from ${invite.companyName}.`,
                });
                if (accept && onAccepted) onAccepted(invite);
                return load();
            })
            .catch(err => {
                setMessage({ type: "danger", text: (err.response && err.response.data && (err.response.data.message || err.response.data)) || "Could not answer the invitation." });
                return load();
            })
            .finally(() => setBusyId(null));
    };

    if (invites === null) return <div className="text-muted">Loading invitations...</div>;

    return (
        <div data-testid="my-invitations">
            {message && (
                <div className={`alert alert-custom alert-light-${message.type} mb-6`} role="alert">
                    <div className="alert-text font-weight-bold">{typeof message.text === "string" ? message.text : "Something went wrong."}</div>
                </div>
            )}
            {invites.length === 0 ? (
                <div className="text-muted">You have no pending invitations.</div>
            ) : (
                invites.map(invite => (
                    <div key={invite._id} className="d-flex flex-wrap align-items-center justify-content-between border rounded p-5 mb-4">
                        <div className="mr-4">
                            <div className="font-weight-bolder font-size-h6">{invite.companyName}</div>
                            <div className="text-muted">
                                {invite.inviterName ? `Invited by ${invite.inviterName}` : "Invitation"}
                                {invite.roleName ? ` as ${invite.roleName}` : ""}
                                {invite.expiresAt ? ` - expires ${new Date(invite.expiresAt).toLocaleDateString()}` : ""}
                            </div>
                        </div>
                        <div className="mt-3 mt-md-0">
                            <button type="button" className="btn btn-primary font-weight-bold mr-2" disabled={busyId === invite._id} onClick={() => answer(invite, true)}>
                                Accept
                            </button>
                            <button type="button" className="btn btn-light-danger font-weight-bold" disabled={busyId === invite._id} onClick={() => answer(invite, false)}>
                                Decline
                            </button>
                        </div>
                    </div>
                ))
            )}
        </div>
    );
}
